import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { MultiSelectBuildProps } from 'components/molecules/MultiSelectBuild'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

const optionsStatus = [
    {
        text: 'Registrado ',
        value: 'REGISTRADO'
    },
    {
        text: 'Parcialmente Registrado',
        value: 'PARCIALMENTE_REGISTRADO'
    },
    {
        text: 'Recusado',
        value: 'RECUSADO'
    }
]

export const formFilter: {
    input?: InputBuildProps
    select?: SelectBuildProps
    multiSelect?: MultiSelectBuildProps
    layout?: any
}[] = [
        {
            input: {
                id: 'periodoInicial',
                label: 'Data Inicial (Data Registro)',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'periodoFinal',
                label: 'Data Final',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'status',
                label: 'Status',
                options: optionsStatus
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            multiSelect: {
                id: 'ufDetran',
                label: 'Detran',
                optionsType: 'ufContract'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'possuiImagem',
                label: 'Possui Imagem?',
                options: [
                    {
                        value: true,
                        text: 'Sim'
                    },
                    {
                        value: false,
                        text: 'Não'
                    }
                ]
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            multiSelect: {
                id: 'tipoOperacao',
                label: 'Tipo de Serviço',
                optionsType: 'operationWithoutALL'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'origem',
                label: 'Tipo de Origem',
                optionsType: 'origin'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'chassi',
                label: 'N° Chassi'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroContrato',
                label: 'N° Contrato'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroGravame',
                label: 'N° Gravame'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        }
    ]
